import { memo } from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Label,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { roundLargeNumbers } from "../../../../utils/formatNumber";
import { BillsBarChartToolTip } from "../ChartToolTips";

const HorizontalBarChart = ({ data, label, closedLabel, groupedDate }) => {
  const isEmpty = data.some((info) => info.empty !== undefined);

  const hasCredit = data.some((info) => info.credit);
  const situations = {
    open: { fill: "#3366cc", label: "A Vencer" },
    closed: { fill: "#7fc8a9", label: closedLabel },
    expired: { fill: "#fa8072", label: "Vencido" },
  };

  if (hasCredit) situations["credit"] = { fill: "#FFD600", label: "Crédito" };

  if (isEmpty)
    situations["empty"] = { fill: "#f4f4f4", label: "Sem movimentação" };

  const maxBarWidth = 18;
  return (
    <ResponsiveContainer height={350}>
      <BarChart
        width={600}
        height={300}
        data={data}
        layout="horizontal"
        margin={{
          top: 8,
          right: 40,
          bottom: 40,
          left: 42,
        }}
      >
        <XAxis
          type="category"
          name="Data"
          dataKey="name"
          xAxisId={0}
          angle={325}
          dy={15}
          dx={-15}
          interval={"preserveStart"}
        >
          <Label dy={40} dx={-30} value={label} />
        </XAxis>

        <YAxis type="number" yAxisId={0} tickFormatter={roundLargeNumbers}>
          <Label angle={270} dx={-64} value="Valor (R$)" />
        </YAxis>

        <CartesianGrid stroke="#d0d0d0" strokeDasharray="5 5" />
        <Tooltip content={<BillsBarChartToolTip groupedDate={groupedDate} />} />
        <Legend layout="horizontal" verticalAlign="top" align="center" />

        {isEmpty ? (
          <Bar
            stackId="valor"
            name="Sem movimentação"
            dataKey="empty"
            fill="#f4f4f4"
            barSize={maxBarWidth}
          />
        ) : (
          Object.entries(situations).map(([key, value]) => (
            <Bar
              key={key}
              stackId="valor"
              name={value.label}
              dataKey={key}
              fill={value.fill}
              barSize={maxBarWidth}
            />
          ))
        )}
      </BarChart>
    </ResponsiveContainer>
  );
};

export default memo(HorizontalBarChart);
